import { render, staticRenderFns } from "./tplRecord.vue?vue&type=template&id=7f57d59e&scoped=true&"
import script from "./tplRecord.vue?vue&type=script&lang=js&"
export * from "./tplRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f57d59e",
  null
  
)

export default component.exports